import 'imagesloaded';

class ProductsSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: 2000,
            pageDots: true,
            wrapAround: true,
            initialIndex: 0,
            prevNextButtons: false,
            cellAlign: 'left',
            // fade: true,
            cellSelector: '.product-miniature'
        };

        if(this.$el.length) {
            this._init();
        }
    }

    _init() {
        this.$slides = this.$el.find('.product-miniature');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 0) {
            this._createSlider();
        }
    }

    _createSlider() {
        // if(window.innerWidth >= 768) {
        //     this.options.initialIndex = Math.floor((this.slidesCount - 1) / 2);
        // }

        imagesLoaded(this.$el[0], (instance) => {
            this.$el.flickity(this.options);
        });
    }
}

export default ProductsSlider;
